'use strict';

require('pixi');

require('p2');

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

var _Boot = require('./states/Boot');

var _Boot2 = _interopRequireDefault(_Boot);

var _Splash = require('./states/Splash');

var _Splash2 = _interopRequireDefault(_Splash);

var _Game = require('./states/Game');

var _Game2 = _interopRequireDefault(_Game);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Game = function (_Phaser$Game) {
    _inherits(Game, _Phaser$Game);

    function Game() {
        _classCallCheck(this, Game);

        var docElement = document.documentElement;
        var width = docElement.clientWidth > _config2.default.gameWidth ? _config2.default.gameWidth : docElement.clientWidth;
        var height = docElement.clientHeight > _config2.default.gameHeight ? _config2.default.gameHeight : docElement.clientHeight;

        var _this = _possibleConstructorReturn(this, (Game.__proto__ || Object.getPrototypeOf(Game)).call(this, width, height, _phaser2.default.CANVAS, 'content', null));

        _this.state.add('Boot', _Boot2.default, false);
        _this.state.add('Splash', _Splash2.default, false);
        _this.state.add('Game', _Game2.default, false);

        _this.state.start('Boot');
        return _this;
    }

    return Game;
}(_phaser2.default.Game);

window.game = new Game();


//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = 333
// module chunks = 0